import { Tab, Tabs } from '@mui/material';
import {
  CatalogSearchField,
  CatalogSearchFieldCounts,
  CatalogSearchTrackHit,
} from '../../../lib/types';

export const CATALOG_SEARCH_HINT =
  'Hints: artist:"Tom Petty"  album:Fever  track:Dream — quotes only for more than one word. Unhinted terms still search everything.';

export const CATALOG_SEARCH_PLACEHOLDER =
  '... name, album, artist — or artist:"Tom Petty"';

const TABS: {
  searchOn: CatalogSearchField;
  label: string;
  countKey: keyof CatalogSearchFieldCounts;
}[] = [
  { searchOn: 'ALL', label: 'All', countKey: 'all' },
  { searchOn: 'ARTIST_NAME', label: 'Artist', countKey: 'artistName' },
  { searchOn: 'ALBUM_NAME', label: 'Album', countKey: 'albumName' },
  { searchOn: 'TRACK_NAME', label: 'Title', countKey: 'trackName' },
];

function tabLabel(label: string, count: number | null | undefined) {
  if (count == null) return label;
  return `${label} (${count.toLocaleString()})`;
}

export function rowsFromTrackHits<T extends { id: number }>(
  hits: CatalogSearchTrackHit<T>[] | null | undefined
): (T & { rankingScore: number | null; keywordScore: number | null })[] {
  return (hits || [])
    .filter((h) => h && h.track)
    .map((h) => ({
      ...h.track,
      rankingScore: h.rankingScore,
      keywordScore: h.keywordScore,
    }));
}

export const CatalogSearchFieldTabs = ({
  value,
  counts,
  onChange,
}: {
  value: CatalogSearchField;
  counts: CatalogSearchFieldCounts | null;
  onChange: (next: CatalogSearchField) => void;
}) => {
  return (
    <Tabs
      value={value}
      onChange={(_e, next) => onChange(next as CatalogSearchField)}
      sx={{ minHeight: 36, mt: 0.5 }}
    >
      {TABS.map((tab) => (
        <Tab
          key={tab.searchOn}
          value={tab.searchOn}
          label={tabLabel(tab.label, counts?.[tab.countKey])}
          sx={{ minHeight: 36, py: 0, textTransform: 'none' }}
        />
      ))}
    </Tabs>
  );
};
